export const getErrorStringFromAPIError = (error: any): string => {
  return error.response?.data?.errors?.title?.toString() || error.toString();
};
